<script setup lang="ts">
import type { IconSize } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';

export interface GrammarSecondaryButtonProps {
  size?: 'small' | 'regular';
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  iconTemplate?: IconConstant | '';
  iconPosition?: 'leading' | 'trailing' | 'top';
  iconOnlySize?: IconSize;
}

const props = withDefaults(defineProps<GrammarSecondaryButtonProps>(), {
  size: 'regular',
  label: '',
  ariaLabel: '',
  disabled: false,
  iconTemplate: '',
  iconPosition: 'leading',
  iconOnlySize: 'large',
});
const emit = defineEmits(['click']);
</script>

<template>
  <tpg-secondary-button v-bind="props" @tpg-click="() => emit('click')" />
</template>
